exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table .sub td:nth-child(3n+5),\ntable tbody td:nth-child(3n+5) {\n  padding-right: 20px; }\n\n@media only screen and (max-width: 992px) {\n  table.responsive-table thead {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/projektyWeb/McComp_Flota/Front/src/app/pages/dashboard/cards/limits-summary/limits-summary.component.scss
// module id = ../../../../../src/app/pages/dashboard/cards/limits-summary/limits-summary.component.scss
// module chunks = main